import { Box, Switch, Typography } from "@material-ui/core";
import { NightsStay, WbSunny } from "@material-ui/icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTheme } from "src/redux/actions";

function ThemeChange({ color }) {
  const theme = useSelector((state) => state.theme);
  const dispatch = useDispatch();

  const handleTheme = (theme) => {
    dispatch(updateTheme(theme === "light" ? "dark" : "light"));
  };

  return (
    <Box
      padding="4px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      style={{
        marginTop: "5px",
        width: "100px", 
        marginRight: "5px",
      }}
    >
      <WbSunny
        onClick={() => handleTheme("dark")}
        style={{ cursor: "pointer", width: "20px", height: "20px" }}
      />
      <Switch
        checked={theme === "dark"}
        onChange={() => handleTheme(theme)}
        name="checkedA"
        inputProps={{ "data-testid": "dark-mode" }}
      />
      <NightsStay
        onClick={() => handleTheme("light")}
        style={{ cursor: "pointer", width: "20px", height: "20px", marginLeft: "0px"}}
      />
      <Typography
        data-testid="dark-mode-text"
        style={{
          display: "none",
          color: "white !important",
        }}
        id="dark-mode-text"
        variant="body2"
        color="textSecondary"
      >
        {theme === "dark" ? "Dark" : "Light"}
      </Typography>
    </Box>
  );
}

export default ThemeChange;
